import React from 'react';
import classNames from 'classnames';

import { image as imagePropTypes } from 'lib/CustomPropTypes';
import Picture from 'components/Picture';
import Caption from 'components/Caption';
import AIMS_FLAVORS from 'lib/aimsFlavors';

import styles from './styles.module.scss';

function ImageLiftout({ content }) {
  // todo: imageTitle and image subtitle are not longer valid. find what replaced.
  const { href, blank } = content; // , imagetitle, imagesubtitle
  const {
    altText, caption, headline, source, url,
  } = content.image;
  const sourceText = (source && source.name) || '';
  const copyrightText = (source && source.copyright) || '';
  const alt = `Image::${altText}|${sourceText}${copyrightText ? `|${copyrightText}` : ''}`;

  const pic = (
    <div
      className={classNames(
        styles.overlay,
        {
          [styles.opacityTitle]: headline.primary,
        },
      )}
    >
      <Picture
        responsiveFlavors={{
          s: AIMS_FLAVORS.FOCAL_320x160,
          m: AIMS_FLAVORS.FOCAL_678x339,
          l: AIMS_FLAVORS.FOCAL_920x460,
          xl: AIMS_FLAVORS.FOCAL_1160x580,
        }}
        alt={alt}
        url={url.primary}
        className={styles.theimg}
      />
      <span className={styles.label}>{caption}</span>
    </div>
  );

  return (
    <figure className={classNames(styles.container, 'mv8')}>
      { href
        ? <a href={href} target={blank ? '_blank' : null} title={caption}>{pic}</a>
        : pic }
      <Caption
        image={content.image}
        className={classNames(styles.caption, ['mt4', 'mb0'])}
      />
    </figure>
  );
}

export default ImageLiftout;

ImageLiftout.propTypes = imagePropTypes.isRequired;
